import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import {
  getLifter,
  getScreenMedia
} from 'selectors';
import Table from 'components/table/Table';
import DefaultCell from './cells/DefaultCell';
import ThumbsUpIcon from 'icons/ThumbsUpIcon';
import ThumbsDownIcon from 'icons/ThumbsDownIcon';

const Result = ({result}) => {
  if(result === 'good') {
    return <ThumbsUpIcon className="good" />;
  } else if(result === 'bad') {
    return <ThumbsDownIcon className="bad" />;
  } else {
    return null;
  }
};

const FaultCards = ({attempt, position}) => {
  return (
    <div className="fault-cards">
      <Result result={_.get(attempt, ['decisions', position, 'decision'])} />
      { _.get(attempt, ['decisions', position, 'cards', 'red']) &&
        <div className="fault-card red" />
      }
      { _.get(attempt, ['decisions', position, 'cards', 'blue']) &&
        <div className="fault-card blue" />
      }
      { _.get(attempt, ['decisions', position, 'cards', 'yellow']) &&
        <div className="fault-card yellow" />
      }
    </div>
  );
};

class AttemptTable extends Component {
  getAllColumns = () => {
    return [
      {key: 'name', label: 'Lift', width: 80, renderer: DefaultCell},
      {key: 'weight', label: 'Weight', width: 65, renderer: DefaultCell},
      {key: 'result', label: 'Result', width: 65, renderer: DefaultCell},
      {key: 'left', label: 'Left', width: 170, renderer: DefaultCell},
      {key: 'head', label: 'Head', width: 170, renderer: DefaultCell},
      {key: 'right', label: 'Right', width: 170, renderer: DefaultCell}
    ];
  }

  getCellLines = () => {
    return 1;
  }

  render() {
    const { lifter, media } = this.props;
    const lifts = _.get(lifter, 'lifts');
    const attempts = [
      _.get(lifts, ['squat', 1]),
      _.get(lifts, ['squat', 2]),
      _.get(lifts, ['squat', 3]),
      _.get(lifts, ['bench', 1]),
      _.get(lifts, ['bench', 2]),
      _.get(lifts, ['bench', 3]),
      _.get(lifts, ['dead', 1]),
      _.get(lifts, ['dead', 2]),
      _.get(lifts, ['dead', 3])
    ];

    const dataArray = _.map(attempts, (attempt) => {
      return {
        ...attempt,
        name: `${attempt.liftName} ${attempt.attemptNumber}`,
        weight: attempt.weight,
        result: (<Result result={attempt.result} />),
        left: (<FaultCards attempt={attempt} position="left" />),
        head: (<FaultCards attempt={attempt} position="head" />),
        right: (<FaultCards attempt={attempt} position="right" />)
      };
    });

    dataArray.unshift({row: 'header'});

    return (
      <div className="attempt-table">
        <Table
          numberOfFixedLeftColumns={1}
          data={dataArray}
          columns={this.getAllColumns()}
          getCellLines={this.getCellLines}
          meet={this.props.meet}
          media={media}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    lifter: getLifter(state, props),
    media: getScreenMedia(state, props)
  };
};

const actions = {};

export default withRouter(connect(mapStateToProps, actions)(AttemptTable));
